<template>
  <div @click="handleClick">
    <sr-timer-btn ref="timerRef" :disabled="DISABLED.TIMER"></sr-timer-btn>
  </div>
</template>

<script>
import { toRefs, reactive, computed } from 'vue'
import { sendEmailCode } from '@/api/modules/user'
// import { platformChannel } from '@/config/setting.config'
import { validator } from '@libs/utils'
import { components } from '@libs/ui'
import { useI18n } from "@/plugins/i18n"

export default {
  name: 'sr-email-code-btn',
  components: {
    SrTimerBtn: components.SrTimerBtn
  },
  props: {
    email: {
      type: String,
      default: ''
    },
    emailId: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    }
  },
  setup(props, ctx) {
    const { locale, switchLang, lang } = useI18n()
    const state = reactive({
      operatorFlag: true
    })

    const ref = reactive({
      timerRef: null
    })

    const scopedComputed = {
      DISABLED: computed(() => {
        return {
          TIMER: (function() {
            return props.disabled || !validator.isEmail(props.email)
          })()
        }
      })
    }

    const scopedMethods = {
      handleClick: () => {
        if (scopedComputed.DISABLED.value.TIMER) {
          return false
        }

        scopedMethods.sendCellphoneCode()
      },
      sendCellphoneCode: async () => {
        try {
          const result = await sendEmailCode({
            email: props.email,
            type: props.type,
            language: locale
            // platformChannel
          })
          ref.timerRef.startTimer()

          ctx.emit('update:emailId', result.emailId)
        } catch (e) {
          console.log(`%c 错误捕捉`, 'color:#f00', e)
        }
      }
    }

    return {
      ...toRefs(state),
      ...toRefs(ref),
      ...scopedComputed,
      ...scopedMethods
    }
  }
}
</script>

<style scoped>

</style>
